import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button, Table } from 'react-bootstrap'
import Card from '../../../components/Card'
import ToastNotification from '../../../components/Toast';
import { toast } from 'react-toastify';
import { API_CALL_CENTRE_PROFILE, API_COUNTRY_CODES_LIST, API_TIMEZONES_LIST, API_PARENT_CALL_CENTER_LICENCE, API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, API_USER_COUNTRY_CODE_DIRECTIONS_BY_CALL_CENTRE } from '../../../service/url';
import CountryCodeDirectionPicker from '../../../components/partials/dashboard/country-code-direction/CountryCodeDirectionPicker';
import { postApiCall, getApiCall, fetchAndSetFlashMessage } from '../../../service/httpCall';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES, USER_ROLES, MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT  } from '../../../utilities/constant';
import { useAuth, errorCheck } from '../auth/auth-utils';

import { Storage } from "../../../utilities/setting";

const CallCentreUpdate = () => {

   const { id } = useParams();
   const navigate = useNavigate();
   const { checkAuth } = useAuth();
   const [name, setName] = useState('');
   const [domain, setDomain] = useState('');
   const [description, setDescription] = useState('');
   //const [status, setStatus] = useState('');
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [countryCodeList, setCountryCodeList] = useState([]);
   const [countryCode, setCountryCode] = useState('');
   const [timezonesList, setTimezonesList] = useState([]);
   const [timezone, setTimezone] = useState('');
   const [filteredTimezones, setFilteredTimezones] = useState([]);
   const [licence, setLicence] = useState('');
   const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
   const [agent, setAgent] = useState(0);
   const [liveAgent, setLiveAgent] = useState(0);
   const [channel, setChannel] = useState(0);
   const [asReseller, setAsReseller] = useState(0);
   const [asCompany, setAsCompany] = useState(0);
   const [availableLicence, setAvailableLicence] = useState({});
   const [errors, setErrors] = useState({});
   const [totalLicence, setTotalLicence] = useState({});
   const [usedLicence, setUsedLicence] = useState({});
   const [loginUserRole, setLoginUserRole] = useState(null);  
   const [parentLicence, setParentLicence] = useState(null);
   const [initialLicence, setInitialLicence] = useState({});
   const [nameError, setNameError] = useState('');
   const [domainError, setDomainError] = useState('');
   const [notes, setNotes] = useState([]);
   const [countryCodeDirections, setCountryCodeDirections] = useState([]);
   const [selectedCountryCodeDirections, setSelectedCountryCodeDirections] = useState([]);

   function getProfileApiUrl() {
      return API_CALL_CENTRE_PROFILE.replace(':id', id);
   }
         useEffect(() => {
            getUser();

                fetchAndSetFlashMessage(
                  msg => msg.module_name === MODULE_ACL.CALL_CENTRE && msg.action === FLASH_MESSAGE_ACTION_OBJECT.EDIT && msg.type === 'Note',
                  setNotes
                );
         }, [])

   useEffect(() => {
      checkAuth(setToastProps, setShowToast)
    }, []);
  

   useEffect(() => {

      const profileApiUrl = getProfileApiUrl();
      getApiCall(profileApiUrl, {})
         .then(resp => {
            setName(resp.name);
            setDomain(resp.domain);
            setDescription(resp.description);
            //  setStatus(resp.status);
            setCountryCode(resp.country_code_id);
            setTimezone(resp.timezone_id);
         }).catch(onError);

      getApiCall(API_COUNTRY_CODES_LIST, {})
         .then(onCountryCodeListSuccess)
         .catch(onError);

      getApiCall(API_TIMEZONES_LIST, {})
         .then(onTimezonesListSuccess)
         .catch(onError);

      getApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, {})
         .then(data => setCountryCodeDirections(Array.isArray(data) ? data : []))
         .catch(() => setCountryCodeDirections([]));

      getApiCall(API_USER_COUNTRY_CODE_DIRECTIONS_BY_CALL_CENTRE(id), {})
         .then(data => {
            const ids = Array.isArray(data)
               ? data.map(item => item.country_code_direction_id).filter(Boolean)
               : [];
            setSelectedCountryCodeDirections(ids);
         })
         .catch(() => {});

   getApiCall(profileApiUrl, {})
   .then(resp => {
    
      
      // Fix: Access the licence object correctly
      // const licence = resp?.subUserLicenceId || {};
      // const available = licence?.available_licence || {};
      // const total = licence?.total_licence || {};

      // setAvailableLicence(available);
      // setTotalLicence(total);

      // // Calculate used licence
      // const calculatedUsed = Object.fromEntries(
      //    Object.keys(total).map(key => [key, total[key] - (available[key] || 0)])
      // );

      // setUsedLicence(calculatedUsed);

      // // Set individual licence values
      // setCallCenterAdminTeamlead(available.role_ccadmin || 0);
      // setAgent(available.role_ccagent || 0);
      // setLiveAgent(available.live_agent || 0);
      // setChannel(available.channel || 0);
      // setAsReseller(available.reseller || 0);
      // setAsCompany(available.company || 0);
      const licence = resp?.subUserLicenceId || {};
    const available = licence?.available_licence || {};
    const total = licence?.total_licence || {};
    const used = licence?.used_licence || {};

    setAvailableLicence(available);
    setTotalLicence(total);

// const calculatedUsed = Object.fromEntries(
//   Object.keys(total).map(key => {
//     const used = Number(total[key] || 0) - Number(available[key] || 0);
//     return [key, Math.max(0, used)];
//   })
// );

// setUsedLicence(calculatedUsed);
setUsedLicence(used);


    // Set current licence values (what user sees/edits)
    const currentValues = {
      // role_ccadmin: available.role_ccadmin || 0,
      role_ccagent: available.role_ccagent || 0,
      live_agent: available.live_agent || 0,
      channel: available.channel || 0,
      reseller: available.reseller || 0,
      company: available.company || 0,
    };

   //  setCallCenterAdminTeamlead(currentValues.role_ccadmin);
    setAgent(currentValues.role_ccagent);
    setLiveAgent(currentValues.live_agent);
    setChannel(currentValues.channel);
    setAsReseller(currentValues.reseller);
    setAsCompany(currentValues.company);

    // Save initial values for comparison
    setInitialLicence(currentValues);
   }).catch(onError);
   }, [id]);

   // useEffect(() => {

   //    if (toastProps) {
   //       setShowToast(true);
   //    }

   // }, [toastProps]);

   function onCountryCodeListSuccess(resp) {
      setCountryCodeList(resp);
   }


   function onTimezonesListSuccess(resp){
      setTimezonesList(resp);
   }

   useEffect(() => {
  if (!countryCode || !timezonesList.length || !countryCodeList.length) return;

  const selectedCountry = countryCodeList.find(c => c.id === countryCode);
  if (selectedCountry) {
    const filtered = timezonesList.filter(tz =>
      tz.value.toLowerCase().includes(selectedCountry.name.toLowerCase())
    );
    setFilteredTimezones(filtered);
  } else {
    setFilteredTimezones([]);
  }
}, [countryCode, timezonesList, countryCodeList]);

const validateInput = (value, key) => {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;

  // if (!usedLicence || Object.keys(usedLicence).length === 0) {
  //   return num;
  // }

  if (num < 0) {
    setErrors(prev => ({ ...prev, [key]: "Value cannot be negative" }));
    return num;
  }

  const licenceKeyMap = {
    role_ccadmin: "role_ccadmin",
    agent: "role_ccagent",
    live_agent: "live_agent",
    channel: "channel",
  };

  const licenceKey = licenceKeyMap[key];
  // const used =
  //   Number.isFinite(Number(usedLicence?.[licenceKey]))
  //     ? Number(usedLicence[licenceKey])
  //     : 0;

  // if (num < used) {
  //   setErrors(prev => ({
  //     ...prev,
  //     [key]: `Cannot be less than already used (${used})`,
  //   }));
  //   return num;
  // }

  const initialValue = Number(initialLicence?.[licenceKey] || 0);
  const parentAvailable = Number(parentLicence?.available_licence?.[licenceKey] || 0);
  const maxAllowed = parentAvailable + initialValue;

  if (num > maxAllowed) {
    setErrors(prev => ({
      ...prev,
      [key]: `Value cannot exceed ${maxAllowed}`,
    }));
    return num;
  }

  setErrors(prev => ({ ...prev, [key]: "" }));
  return num;
};

async function getUser(){
  try {
   const user = JSON.parse(Storage.getItem('user'));
   if (user) {
     setLoginUserRole(user.role);
   }
  } catch(err){
    console.log(err)
  }
}

   const handleCountryChange = (e) => {
    const selectedCountryId = e.target.value;
    setCountryCode(selectedCountryId);

    const selectedCountry = countryCodeList.find(c => c.id === selectedCountryId);
    if (selectedCountry) {
        const filtered = timezonesList.filter(tz => tz.value.toLowerCase().includes(selectedCountry.name.toLowerCase()));
        setFilteredTimezones(filtered);
    } else {
        setFilteredTimezones([]);
    }
};

   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
       errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      console.log(err)
    }
   }

   const validateName = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
         setNameError("Name is required");
         return false;
      }
      if (trimmedValue.length < 3) {
         setNameError("Name must be at least 3 characters long");
         return false;
      }
      if (trimmedValue.length > 500) {
         setNameError("Name must not exceed 500 characters");
         return false;
      }
      // Allow only letters, numbers, and underscores
      const nameRegex = /^[a-zA-Z0-9_]+$/;
      if (!nameRegex.test(trimmedValue)) {
         setNameError("Name can only contain letters, numbers, and underscores (_). No special characters allowed.");
         return false;
      }
      setNameError("");
      return true;
   };

   const validateDomain = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
         setDomainError("Domain is required");
         return false;
      }
      if (trimmedValue.length > 500) {
         setDomainError("Domain must not exceed 500 characters");
         return false;
      }
      // Basic URL/domain validation - allows http://, https://, or just domain
      // More permissive to allow @ and other characters
      const domainRegex = /^(https?:\/\/)?([\w\.\-@]+)([\/\w \.\-@]*)*\/?$/i;
      if (!domainRegex.test(trimmedValue)) {
         setDomainError("Please enter a valid domain or URL (e.g., example.com or https://example.com)");
         return false;
      }
      setDomainError("");
      return true;
   };

   function validateForm() {

      let valid = true;
      let errorMessage = '';

      // Validate name and domain first
      const nameValid = validateName(name);
      const domainValid = validateDomain(domain);

      if (!nameValid) {
         valid = false;
         errorMessage = nameError || "Name validation failed";
      }
      if (!domainValid) {
         valid = false;
         if (errorMessage) {
            errorMessage += "; " + (domainError || "Domain validation failed");
         } else {
            errorMessage = domainError || "Domain validation failed";
         }
      }
      if (!description.trim()) {
         valid = false;
         if (errorMessage) {
            errorMessage += "; Description required";
         } else {
            errorMessage = "Description required";
         }
      }
      if (!timezone.trim()) {
        valid = false;
        if (errorMessage) {
           errorMessage += "; Timezone required";
        } else {
           errorMessage = "Timezone required";
        }
      }

      if (!valid && errorMessage) {
         toast.warning(errorMessage);
      }

      return valid;

   }

async function submitForm() {
  setButtonDisable(true);

  if (!validateForm()) {
    setButtonDisable(false);
    return;
  }

  // Block submit if any licence errors exist
  if (Object.values(errors).some(error => error !== "")) {
    toast.warning("Please fix all validation errors before submitting")
    setButtonDisable(false);
    return;
  }

//   if (liveAgent > 10) {
//     toast.warning("Live Agent cannot exceed 10")
//     setButtonDisable(false);
//     return;
//   }

  const params = {
    name,
    domain,
    description,
    countryCode,
    timezone,
    licence: {
      // role_ccadmin: callCenterAdminTeamlead,
      role_ccagent: agent,
      live_agent: liveAgent,
      channel,
      reseller: asReseller,
      company: asCompany,
    },
    country_code_directions: Array.isArray(selectedCountryCodeDirections)
      ? selectedCountryCodeDirections.map(Number)
      : [],
  };

  const profileApiUrl = getProfileApiUrl();
  postApiCall(profileApiUrl, params)
    .then(onCallCentreUpdateSuccess)
    .catch(onCallCentreUpdateError);
}


   function onCallCentreUpdateSuccess(resp) {
        toast.success("Call centre updated successfully")
      setTimeout(() => {
         navigate(`/${ROUTES.CALL_CENTRES.LIST}`);
      }, 1500);
   }

   function onCallCentreUpdateError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        setButtonDisable(false);
        toast.warning(JSON.stringify(err))
      }
   }

   //    function RenderUserStatusOptions(){

   //       let arrStatusOptions = [<option value=''>Select status</option>]

   //       USER_STATUS.map( val => {
   //          arrStatusOptions.push(<option value={val.value}>{val.label}</option>);
   //       } )

   //       return arrStatusOptions;

   //    }

   useEffect(() => {
          getApiCall(API_PARENT_CALL_CENTER_LICENCE).then((resp) => {
            setParentLicence(resp?.parentLicence);
          }).catch((error) => {
            toast.warning(JSON.stringify(error))
          });
         }, []);

   return (
      <>
         <div>
            <Row>
               <Col xl="12" lg="12">
                  <Card>
                     <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">Call Centre Information</h4>
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <div className="new-user-info">
                           <form>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="name">Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control 
                                       type="text" 
                                       id="name" 
                                       placeholder="Enter call centre Name" 
                                       maxLength={500} 
                                       value={name} 
                                       onChange={e => {
                                          setName(e.target.value);
                                          validateName(e.target.value);
                                       }}
                                       onBlur={e => validateName(e.target.value)}
                                       isInvalid={!!nameError}
                                       required 
                                    />
                                    {nameError && <Form.Control.Feedback type="invalid">{nameError}</Form.Control.Feedback>}
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="domain">Domain: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control 
                                       type="text" 
                                       id="domain" 
                                       maxLength={500} 
                                       value={domain} 
                                       onChange={e => {
                                          setDomain(e.target.value);
                                          validateDomain(e.target.value);
                                       }}
                                       onBlur={e => validateDomain(e.target.value)}
                                       isInvalid={!!domainError}
                                       required 
                                    />
                                    {domainError && <Form.Control.Feedback type="invalid">{domainError}</Form.Control.Feedback>}
                                 </Form.Group>
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="countryCode">Select Country Code: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Select id="countryCode" required value={countryCode} onChange={handleCountryChange}>
                                       <option value={''}>Select</option>
                                       {
                                          countryCodeList.map(function (val, idx) {
                                             return (<option key={idx} value={val.id}>{val.name}</option>)
                                          })
                                       }
                                    </Form.Select>
                                 </Form.Group>

                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="timezone">Select Timezone: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Select id="timezone" required value={timezone} onChange={e => setTimezone(e.target.value)}>
                                       <option value={''}>Select</option>
                                       {
                                          filteredTimezones.map(function (val, idx) {
                                             return (<option key={idx} value={val.id}>{val.value}</option>)
                                          })
                                       }
                                    </Form.Select>
                                 </Form.Group>
                              </div>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="description">Description: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control as="textarea" rows={3} id="description" maxLength={500} value={description} onChange={e => setDescription(e.target.value)} required />
                                 </Form.Group>
                              <div className="row">
                                 <CountryCodeDirectionPicker
                                    items={countryCodeDirections}
                                    selectedIds={selectedCountryCodeDirections}
                                    onChange={setSelectedCountryCodeDirections}
                                    label="Country Codes:"
                                    placeholder="Select country codes"
                                 />
                              </div>
                              {/* <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="status">Status:</Form.Label>
                                    <select value={status} onChange={e => setStatus(e.target.value)} className="form-select" id="status">
                                        <RenderUserStatusOptions/>
                                    </select>
                                 </Form.Group>
                              </div> */}
                              <hr />
                              <div className="scroll-container" style={{ marginBottom: "30px"}}>
                                <h5 style={{ marginBottom: "10px" }}>Current Licence</h5>
                                <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                                  <thead>
                                    <tr>
                                      {/* <th  style={{ width: "15%" }}>Call Centers</th> */}
                                      <th  style={{ width: "15%" }}>Total Agent</th>
                                      <th  style={{ width: "15%" }}>Live Agent</th>
                                      <th  style={{ width: "15%" }}>Channels</th>
                                    </tr>
                                  </thead>
<tbody>
  <tr>
    {/* <td>
      <Form.Group className="form-group">
        <Form.Control
          type="number"
          value={String(parseInt(String(callCenterAdminTeamlead), 10))}
          min={0}
          onChange={(e) => setCallCenterAdminTeamlead(validateInput(e.target.value, "role_ccadmin"))}
        />
        {errors.role_ccadmin && <small className="text-danger">{errors.role_ccadmin}</small>}
      </Form.Group>
    </td> */}

    <td>
      <Form.Group className="form-group">
        <Form.Control
          type="number"
          value={String(parseInt(String(agent), 10))}
          min={0}
          onChange={(e) => setAgent(validateInput(e.target.value, "agent"))}
        />
        {errors.agent && <small className="text-danger">{errors.agent}</small>}
      </Form.Group>
    </td>

    <td>
      <Form.Group className="form-group">
        <Form.Control
          type="number"
          value={String(parseInt(String(liveAgent), 10))}
         //  max={10}
          onChange={(e) => setLiveAgent(validateInput(e.target.value, "live_agent"))}
        />
        {errors.live_agent && <small className="text-danger">{errors.live_agent}</small>}
      </Form.Group>
    </td>

    <td>
      <Form.Group className="form-group">
        <Form.Control
          type="number"
          value={String(parseInt(String(channel), 10))}
          min={0}
          onChange={(e) => setChannel(validateInput(e.target.value, "channel"))}
        />
        {errors.channel && <small className="text-danger">{errors.channel}</small>}
      </Form.Group>
    </td>
  </tr>
</tbody>

                                </Table>
                              </div>
                              {/* // */}
                              <div 
                                style={{
                                  background: "#FFF8C6",
                                  color: "#8B5A2B",
                                  padding: "10px 15px",
                                  borderRadius: "6px",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  marginTop:"70px",
                                  marginBottom:"20px"
                                }}
                              >
                                {/* <span><strong>Note:</strong> This licence detail is informational purpose and cannot be edited.</span> */}
                                <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}
                              </div>
                              
                              
                              <div className="scroll-container" style={{ marginBottom: "30px" }}>
                                <h5 style={{ marginBottom: "10px" }}>Available Licence (Allocated Company)</h5>
                                <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                                  <thead>
                                    <tr>
                                      {/* <th>Call Centers</th> */}
                                      <th>Total Agent</th>
                                      <th>Live Agent</th>
                                      <th>Channels</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      {/* <td>{availableLicence?.role_ccadmin || 0}</td>
                                      <td>{availableLicence?.role_ccagent || 0}</td>
                                      <td>{availableLicence?.live_agent || 0}</td>
                                      <td>{availableLicence?.channel || 0}</td> */}
                                      {/* <td>{parentLicence?.available_licence?.role_ccadmin || 0}</td> */}
                                       <td>{parentLicence?.available_licence?.role_ccagent || 0}</td>
                                       <td>{parentLicence?.available_licence?.live_agent || 0}</td>
                                       <td>{parentLicence?.available_licence?.channel || 0}</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                              {/* // */}
                              <div className="scroll-container" style={{ marginBottom: "30px" }}>
                                <h5 style={{ marginBottom: "10px" }}>Used Licence (Current Call Center)</h5>
                                <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                                  <thead>
                                    <tr>
                                       {(loginUserRole !== USER_ROLES.CALL_CENTRE_ADMIN) && (loginUserRole !== USER_ROLES.COMPANY_ADMIN) &&
                                      <th>Call Centers</th>
                                      }
                                      <th>Total Agent</th>
                                      <th>Live Agent</th>
                                      <th>Channels</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                       {(loginUserRole !== USER_ROLES.CALL_CENTRE_ADMIN) && (loginUserRole !== USER_ROLES.COMPANY_ADMIN) &&
                                      <td>{usedLicence?.role_ccadmin || 0}</td>
                                       }
                                      <td>{usedLicence?.role_ccagent || 0}</td>
                                      <td>{usedLicence?.live_agent || 0}</td>
                                      <td>{usedLicence?.channel || 0}</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                              {/* // */}
<Button
  onClick={submitForm}
  type="button"
  variant="btn btn-primary"
  disabled={buttonDisable || Object.values(errors).some(error => error !== "") || !!nameError || !!domainError}
>
  Update Call Centre &nbsp;
  {buttonDisable ? (
    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  ) : null}
</Button>

                           </form>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

      </>
   )

}

export default CallCentreUpdate;